/** A survey's state as a chip (1.7.3): open, not open yet, closed. */
import { useTranslation } from 'react-i18next';
import type { SurveyState } from '@shared/surveys';
import { Icon, type IconName } from '@/components/Icons';

const STATE: Record<SurveyState, { cls: string; icon: IconName }> = {
  ok: { cls: 'conf', icon: 'check' },
  'not-yet': { cls: 'sched', icon: 'clock' },
  closed: { cls: 'done', icon: 'lock' },
};

/** Open · not open yet · closed — a mark and the words, never the colour alone. */
export function SurveyStateChip({ state, testId }: { state: SurveyState; testId?: string }) {
  const { t } = useTranslation();
  const s = STATE[state];
  return (
    <span className={`status has-icon ${s.cls}`} data-testid={testId}>
      <Icon name={s.icon} aria-hidden="true" />
      {t(`surveys.state.${state === 'not-yet' ? 'notYet' : state}`)}
    </span>
  );
}
